import PlantixMapProduct from "./PlantixMapProduct"

export default PlantixMapProduct